import React, { useEffect, useState } from "react";
import NewDrawr from "./NewDrawr";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
const NewHeader = () => {
  const [open, setOpen] = useState(false);
  const [drop, setDrop] = useState(false);
  const [token, settoken] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      settoken(true);
    }
  }, []);

  const hendleToLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  return (
    <>
      <NewDrawr open={open} setOpen={setOpen} />

      <div
        style={{
          position: "fixed",
          top: 0,
          width: "100%",
          zIndex: 999,
          background: "rgba(20,20,20,0.9)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(255,255,255,0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 15px",
          }}
        >
          {/* MENU */}
      <button
  onClick={() => setOpen(!open)}
  style={{
    fontSize: "22px",
    background: "none",
    border: "none",
    color: "#ffd700",
    cursor: "pointer",
  }}
>
  {open ? <FaTimes /> : <FaBars />}
</button>

          {/* LOGO */}
          <Link to="/">
            <img
              src="/img/logo.png"
              alt="logo"
              style={{ height: "65px",width:"168px" }}
            />
          </Link>

          {/* PROFILE */}
          <div style={{ position: "relative" }}>
            <div
              onClick={() => setDrop(!drop)}
              style={{
                width: "35px",
                height: "35px",
                borderRadius: "50%",
                background: "linear-gradient(90deg, #b8860b, #ffd700, #fff3b0, #ffd700, #b8860b)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                cursor: "pointer",
                fontSize: "18px",
                boxShadow: "0 0 10px rgba(0,198,255,0.7)",
              }}
            >
              👤
            </div>

            {/* DROPDOWN */}
            {drop && (
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: "45px",
                  background: "#111",
                  borderRadius: "10px",
                  padding: "10px",
                  minWidth: "120px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  boxShadow: "0 0 15px rgba(0,0,0,0.5)",
                }}
              >
                <Link
                  to="/profile"
                  style={{
                    color: "#ffd700",
                    textDecoration: "none",
                    fontWeight: "bold",
                  }}
                >
                  Profile
                </Link>

                {!token && (
                  <Link
                    to="/login"
                    style={{
                      color: "#ffd700",
                      textDecoration: "none",
                      fontWeight: "bold",
                    }}
                  >
                    Login
                  </Link>
                )}

                {token && (
                  <span
                    onClick={hendleToLogout}
                    style={{
                      color: "#ffd700",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Logout
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewHeader;